var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0062 3.49364e-06C5.38458 -0.00499924 0.00688551 5.3634 6.75959e-06 11.9853C-0.00695016 18.6088 5.35699 23.9894 11.9775 24C18.6002 24.0107 23.9858 18.648 24 12.0288C24.0141 5.40444 18.6304 0.00500623 12.0062 3.49364e-06ZM6.96464 8.40331C6.56736 8.00603 6.56736 7.36191 6.96464 6.96463C7.36192 6.56735 8.00604 6.56735 8.40332 6.96463L12 10.5613L15.5967 6.96464C15.994 6.56736 16.6381 6.56736 17.0354 6.96464C17.4327 7.36192 17.4327 8.00604 17.0354 8.40332L13.4387 12L17.0354 15.5967C17.4327 15.994 17.4327 16.6381 17.0354 17.0354C16.6381 17.4327 15.994 17.4327 15.5967 17.0354L12 13.4387L8.40332 17.0354C8.00604 17.4327 7.36192 17.4327 6.96464 17.0354C6.56736 16.6381 6.56736 15.994 6.96464 15.5967L10.5613 12L6.96464 8.40331Z",
    fill: "#005CA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.9eb1de2189ad8d8d97cbb577eb19c7c2.svg";
export { ForwardRef as ReactComponent };